//bao migrate skip
import TabController from "./tab-controller";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import { IMenu } from "./../interfaces/imenu";
import TabPage from "./tab-page";
import BaoDialog from "./../factories/bao-dialog";
abstract class BaseViewModel2 implements Factories.BaseViewModel2 {
    private _subscriptions: KnockoutSubscription[] = [];
    abstract InitUrl(): string;
    abstract CompleteCheck(): JQueryPromise<boolean> | boolean;
    Menu: IMenu;
    PermissionRefresh: KnockoutObservable<string>;
    PermissionSave: KnockoutObservable<string>;
    PermissionDelete: KnockoutObservable<string>;
    PermissionQRCode: KnockoutObservable<string>;
    PrimaryKeyName: KnockoutObservable<string>;
    PrimaryKeyValue: KnockoutObservable<any>;
    SaveUrl: KnockoutObservable<string>;
    DeleteUrl: KnockoutObservable<string>;
    IsInUseUrl: KnockoutObservable<string>;
    RefreshUrl: KnockoutObservable<string>;
    UnlockUrl: KnockoutObservable<string>;
    TabPage: TabPage;
    TabController: TabController;
    TabName = ko.observable<string>();
    SaveAllowed = ko.observable<boolean>();
    SaveTime = ko.observable();
    Initialized = ko.observable(false);
    IsReadonly = ko.observable(false);
    ShowStatusDialog = ko.observable(false);
    QrLabel = ko.observable("");
    SessionTabId = ko.observable<string>();
    IsNew = ko.observable<boolean>();
    DeleteMessageKey = "msgDelete";
    IsInUseMessageKey = "msgIsInUse";
    SaveCheckMessageKey = "msgSaveCheck";
    Destroy: Function[] = [];
    SettingsUrl: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermission: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermissionApplicationId: KnockoutObservable<string> = ko.observable(null);
    constructor(tabPage: TabPage, menu?: IMenu) {
        this.TabPage = tabPage;
        if (menu != null) {
            this.Menu = menu;
        }
        else {
            this.Menu = this.TabPage.Menu;
        }
        this.registerEvents();
        this.subscribe(this.TabName, (value: string) => {
            this.TabPage.Title(value);
        });
        this.subscribe(this.SaveAllowed, (allowSave) => {
            if (this.Menu != null) {
                this.Menu.permissionEnable({ ActionKey: this.PermissionSave(), Enabled: allowSave, Context: this.TabPage.Context() });
            }
        });
        this.subscribe(this.IsNew, (value) => {
            this.Menu.permissionEnable({ ActionKey: this.PermissionRefresh(), Enabled: !value, Context: this.TabPage.Context() });
        });
    }
    registerEvents() {
        this.TabPage.MenuEvents.push(this.Menu.registerEvent((value) => {
            if (this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case this.PermissionSave():
                        this.DeferredCompleteCheck().then((result) => {
                            if (result == true) {
                                this.Save();
                            }
                        });
                        break;
                    case this.PermissionRefresh():
                        this.BeforeRefresh();
                        break;
                    case this.PermissionDelete():
                        this.BeforeDelete();
                        break;
                    case this.PermissionQRCode():
                        this.GenerateQRCode();
                        break;
                     default:
                        this.CustomToolbarClick(value.ActionKey());
                        break;    
                }
            }
        }));
    }

    CustomToolbarClick(key: string) {
        //dummy!
    }

    Focus() { }
    ;
    DeferredCompleteCheck(): JQueryPromise<any> {
        var def = $.Deferred();
        var resultComplete = this.CompleteCheck();
        //CompleteCheck aufrufen
        if (resultComplete != null && resultComplete["then"] != null) {
            (<JQueryPromise<boolean>>resultComplete).then((result) => {
                if (this.TabController != null) {
                    this.TabController.CompleteCheckTabs().then((resultTabs) => {
                        def.resolve(result && resultTabs);
                    });
                }
                else {
                    def.resolve(result);
                }
            });
        }
        else {
            if (this.TabController != null) {
                this.TabController.CompleteCheckTabs().then((resultTabs) => {
                    def.resolve(resultComplete && resultTabs);
                });
            }
            else {
                def.resolve(resultComplete);
            }
        }
        return def.promise();
    }
    ;
    InitTabController(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        window.baorequire(["Factories/TabController", "Bindings/baoTabs"], (TabController) => {
            this.TabController = new TabController(false);
            def.resolve();
        });
        return def.promise();
    }
    DestroyObject() {
        if (this.Destroy === null) {
            return;
        }
        for (var i = 0; i < this.Destroy.length; i++) {
            if (typeof this.Destroy[i] === "function") {
                this.Destroy[i]();
            }
        }
        for (var y = 0; y < this._subscriptions.length; y++) {
            this._subscriptions[y].dispose();
        }
        this.Destroy = null;
        this._subscriptions = null;
    }
    ;
    /**
     *
     * @param fn
     * @returns JQueryPromise: true if this can closed otherwise false
     */
    BeforeClose(fn): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        if (this.TabPage.DirtyFlag() == true && this.SaveAllowed() === true) {
            window.baorequire(["Factories/baoDialog"], (BaoDialogViewModel) => {
                var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(this.SaveCheckMessageKey), "question");
                this.subscribe(questionDialog.DialogResult, (result) => {
                    if (result === true) {
                        this.DeferredCompleteCheck().then((result) => {
                            if (result == true) {
                                this.TabPage.IsLoading(true);
                                this.Save().done((data) => {
                                    this.TabPage.IsLoading(false);
                                    this.DestroyObject();
                                    this.Unlock().then(() => {
                                        return fn();
                                    }).then(() => {
                                        def.resolve(true);
                                    });
                                });
                            }
                        });
                    }
                    else if (result === false) {
                        this.DestroyObject();
                        this.Unlock().then(() => {
                            return fn();
                        }).then(() => {
                            def.resolve(true);
                        });
                    }
                    else {
                        //result === null
                        def.resolve(false);
                    }
                });
            });
        }
        else {
            this.DestroyObject();
            this.Unlock().then(() => {
                return fn();
            }).then(() => {
                def.resolve(true);
            });
        }
        return def.promise();
    }
    ;
    Unlock(): JQueryPromise<void> {
        if (this.UnlockUrl != null && this.UnlockUrl()) {
            return Bao.post(this.UnlockUrl(), JSON.stringify({ sessionTabId: ko.unwrap(this.SessionTabId) }));
        }
        return $.Deferred().resolve();
    }
    BeforeRefresh() {
        if (this.TabPage.DirtyFlag() == true && (this.SaveAllowed == null || this.SaveAllowed())) {
            window.baorequire(["Factories/baoDialog"], (BaoDialogViewModel) => {
                var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(this.SaveCheckMessageKey), "question");
                this.subscribe(questionDialog.DialogResult, (result) => {
                    if (result == true) {
                        this.DeferredCompleteCheck().then((result) => {
                            if (result == true) {
                                this.Save();
                            }
                        });
                    }
                    else if (result === false) {
                        this.PerformRefresh();
                    }
                });
            });
        }
        else {
            this.PerformRefresh();
        }
    }
    ;
    BeforeDelete() {
        if (this.IsInUseUrl() == "") {
            this.BeforeDeleteQuestion();
        }
        else {
            Bao.post(this.IsInUseUrl(), JSON.stringify({ id: this.PrimaryKeyValue() }), (value) => {
                if (value != "true") {
                    this.BeforeDeleteQuestion();
                }
                else {
                    window.baorequire(["Factories/baoDialog"], (BaoDialogViewModel) => {
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(this.IsInUseMessageKey), "info");
                    });
                }
            });
        }
    }
    ;
    BeforeDeleteQuestion() {
        window.baorequire(["Factories/baoDialog"], (BaoDialogViewModel) => {
            var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(this.DeleteMessageKey), "yesno");
            this.subscribe(yesNoDialog.DialogResult, (result) => {
                if (result === true) {
                    this.Delete();
                }
            });
        });
    }
    ;
    PerformRefresh(model?: any): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        if (model == null) {
            Bao.post(this.RefreshUrl(), JSON.stringify({ id: this.PrimaryKeyValue() }), (value) => {
                this.AfterMainPerformRefresh(value, def);
            });
        }
        else {
            this.AfterMainPerformRefresh(model, def);
        }
        return def.promise();
    }
    ;
    private AfterMainPerformRefresh(value: any, def: JQueryDeferred<void>) {
        this.TabPage.DirtyFlag.pause();
        ko.map.fromJS(value, this, this.TabPage.DirtyFlag);
        this.TabPage.ObjectId(this.PrimaryKeyValue());
        if (this.TabController != null) {
            this.TabController.RefreshTabs().then(() => {
                this.TabPage.DirtyFlag.reset();
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        }
        else {
            this.TabPage.DirtyFlag.reset();
            this.TabPage.IsLoading(false);
            def.resolve();
        }
    }
    GenerateQRCode() {
        window.baorequire(["Factories/QrDialog"], (QrDialog) => {
            var qrDialog = new QrDialog(window.location.href, this.QrLabel());
            qrDialog.Open();
        });
    }
    ;
    MinimizeEntity() {
        var model = ko.map.toJS(this, true);
        for (var o in model) {
            if (typeof model[o] === "object" || typeof model[o] === "function") {
                delete model[o];
            }
        }
        return model;
    };
    Save(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        var def = $.Deferred<void>();

        Bao.post(this.SaveUrl(), JSON.stringify({ model: this.MinimizeEntity() }), (value) => {
            this.HandleSaveResponse(value).then(() => {
                def.resolve();
            })

        });

        return def.promise();
    };
    //This method will handle the reponse and can be overridden 
    HandleSaveResponse(response): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.SaveTime(response.Result);

        if (this.TabController != null) {
            this.TabController.CommitTabs(response.Result).then(() => {
                this.PerformRefresh(response.Model).then(() => {
                    def.resolve();
                });
            });
        }
        else {
            this.PerformRefresh(response.Model).then(() => {
                def.resolve();
            });
        }

        Bao.raiseEvent('user-tagging:save', {});
        return def.promise();
    }
    Delete() {
        this.TabPage.IsLoading(true);
        return Bao.post(this.DeleteUrl(), JSON.stringify({ id: this.PrimaryKeyValue() }), () => {
            this.TabPage.IsLoading(false);
            this.TabPage.DirtyFlag(false);
            window.baorequire(["Services/AppTabController"], (AppTabController) => {
                AppTabController.RemoveTab(this.TabPage);
            });
        });
    }
    ;
    init() {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        if (this.InitUrl() != "") {
            Bao.post(this.InitUrl(), JSON.stringify({ id: this.TabPage.UrlData().id }), (model) => {
                ko.map.fromJS(model.Definition, this);
                ko.map.fromJS(model.Model, this, this.TabPage.DirtyFlag);
                this.TabPage.SessionTabId = this.SessionTabId();
                if (this.IsNew() || (this.TabPage.ObjectId() != this.PrimaryKeyValue())) {
                    this.TabPage.ObjectId(this.PrimaryKeyValue());
                }
                else {
                    this.TabPage.ObjectId.valueHasMutated(); //wegen routing / hash
                }
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    }
    ;
    subscribe<T>(obs: KnockoutObservable<T>, fn: (newValue?: T) => void) {
        this._subscriptions.push(obs.subscribe(fn));
    }
    ;
    loaded() {
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
        this.QrLabel(this.TabPage.Title());
    }
    ;
}
export default BaseViewModel2;